import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimer = setTimeout(() => setIsVisible(true), 3000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-243" data-mp="3n8w3o2scbszm">
      <AnimatePresence mode="wait" data-id="element-244" data-mp="3ks404xsty1nv">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white border border-gold rounded-xl p-3.5 shadow-[0_8px_30px_rgba(18,53,36,0.2)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-245" data-mp="3ppm409rzpqp0">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-warmgray hover:text-forest transition-colors" aria-label="Dismiss notification" data-id="element-246" data-mp="36scjepaxi766">
              <X size={14} data-id="element-247" data-mp="2j2i4m271u8ja" />
            </button>

            <div className="flex items-center gap-3" data-id="element-248" data-mp="2j3t7lzso7c9c">
              <div className="relative shrink-0" data-id="element-249" data-mp="2n1zbn024jdqk">
                <div className="w-11 h-11 rounded-full bg-forest border border-gold flex items-center justify-center text-ivory font-bold text-sm" data-id="element-250" data-mp="2n4vd2yd6kkjr">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" data-id="element-251" data-mp="2dfewizbwiffo" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-252" data-mp="2ierfh8znj2cz">
                <div className="flex items-center gap-1.5 text-[11px] text-warmgray mb-0.5" data-id="element-253" data-mp="2ie9cltihhpw3">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-254" data-mp="2w5ei3c8j9cec" />
                  <span className="truncate" data-id="element-255" data-mp="364df1xjxrjli">{current.location}</span>
                </div>

                <p className="text-ink text-[13px] leading-snug" data-id="element-256" data-mp="316k8h3eq0nkp">
                  <span className="font-bold" data-id="element-257" data-mp="3l7wzybdeb6xa">{current.name}</span>{' '}
                  <span className="text-warmgray" data-id="element-258" data-mp="3p8gxhg1vscjy">
                    purchased Horse Riding Instructor Ready
                  </span>
                </p>

                <div className="flex items-center gap-1.5 text-[10px] text-pine font-medium mt-1" data-id="element-259" data-mp="3tzyyg43wmd4x">
                  <span className="w-1.5 h-1.5 rounded-full bg-pine animate-pulse" data-id="element-260" data-mp="2smczcvzndj7" />
                  <ShoppingBag size={10} data-id="element-261" data-mp="329kp8l6u5ozl" />
                  <span data-id="element-262" data-mp="32alzing127g9">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}